import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Eye } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { PageHeader, Panel, BrandButton } from "@/components/PageHeader";
import { LoginNoticeBox } from "@/components/auth/LoginNoticeBox";
import { api, errMsg, fmtDate } from "@/lib/api";

export default function LoginNotice() {
  const [doc, setDoc] = useState(null);
  const [f, setF] = useState({ text: "", enabled: true });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    api.get("/site/login-notice").then((r) => { if (live) { setDoc(r.data); setF({ text: r.data.text, enabled: r.data.enabled }); } }).catch((e) => toast.error(errMsg(e)));
    return () => { live = false; };
  }, []);
  const dirty = doc && (f.text !== doc.text || f.enabled !== doc.enabled);
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/site/login-notice", f); setDoc(r.data); setF({ text: r.data.text, enabled: r.data.enabled }); toast.success(r.data.enabled ? "Login notice saved and shown" : "Login notice hidden"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="login-notice-page">
      <PageHeader eyebrow="Control" title="Login Page Notice" description="The red notice shown under the Login heading. Edit the text, and switch it on or off."
        actions={<BrandButton onClick={save} disabled={busy || !dirty} data-testid="login-notice-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}Save</BrandButton>} />
      {!doc ? <div className="text-gray-500">Loading…</div> : (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-start">
          <Panel title="Notice">
            <label className="flex items-center gap-3 mb-4 text-sm font-semibold">
              <Switch checked={f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid="login-notice-toggle" />
              {f.enabled ? "Shown on the Login page" : "Hidden from the Login page"}
            </label>
            <Textarea rows={4} maxLength={600} value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} data-testid="login-notice-text" />
            <p className="text-xs text-gray-500 mt-2" data-testid="login-notice-status">{dirty ? "Unsaved changes" : doc.updated_at ? `Last saved ${fmtDate(doc.updated_at)}` : "Showing the starter notice."} · {f.text.length}/600</p>
          </Panel>
          <Panel title={<span className="inline-flex items-center gap-2"><Eye className="w-4 h-4" />What people will see</span>} testId="login-notice-preview">
            {f.enabled && f.text.trim() ? <LoginNoticeBox text={f.text} /> : <p className="text-sm text-gray-500">No notice is shown on the Login page.</p>}
          </Panel>
        </div>
      )}
    </div>
  );
}
